import type { FC } from 'react';
import React from 'react';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import { Money } from '@edreamsodigeo/prisma-design-system';
import { Text } from '@edreamsodigeo/prisma-design-system/deprecated';

import type { Money as IMoney } from '@/generated/graphql';

const FlightSummaryMetaPrice: FC<{ price: IMoney }> = ({ price }) => {
  const { t } = useTranslation();

  return (
    <>
      <Text fontSize="body.2" color="neutral.90">
        {t('flightSummary.pricePerPassenger')}
      </Text>
      <Money currency={price?.currency}>{price?.amount}</Money>
    </>
  );
};

export default FlightSummaryMetaPrice;
